<template>
  <div class="">
    <b-navbar
      class="bg-transparent"
      toggleable="xl"
      type="light"
      variant="light"
      fixed="top"
      id="nav"
      @click="toggleClicked"
    >
      <div class="container-fluid p-0">
        <!-- <b-navbar-brand class="" to="/"> -->
        <router-link to="/">
          <img class="img" src="../../assets/img/logo.png" alt="Logo" />
        </router-link>

        <!-- </b-navbar-brand> -->

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="navbar-thick ml-auto">
            <b-nav-item class="px-1">
              <router-link
                to="/"
                class="r-link"
                active-class="text-inherit"
                exact
                ><a>
                  <icon-vue
                    class="mr-1 text-green f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Home</span></a
                ></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link to="about" class="r-link" active-class="text-inherit"
                ><a>
                  <icon-vue
                    class="mr-1 text-lilac f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">About</span>
                </a></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link
                to="carnival"
                active-class="text-inherit"
                class="r-link"
                ><a>
                  <icon-vue
                    class="mr-1 text-blue-50 f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px"
                    >Carnival {{ new Date().getFullYear() }}</span
                  ></a
                ></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link
                to="reserve"
                class="r-link"
                active-class="text-inherit"
                ><a>
                  <icon-vue
                    class="mr-1 text-lilac f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Vendor Registration</span></a
                ></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link
                to="sponsorship-opportunities"
                class="r-link"
                active-class="text-inherit"
                ><a>
                  <icon-vue
                    class="mr-1 text-lilac f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Sponsorship</span></a
                ></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link
                to="volunteer"
                class="r-link"
                active-class="text-inherit"
                ><a>
                  <icon-vue
                    class="mr-1 text-lilac f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Volunteer</span></a
                ></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <router-link
                to="gallery"
                active-class="text-inherit"
                class="r-link"
                ><a>
                  <icon-vue
                    class="mr-1 text-yellow f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Gallery</span></a
                ></router-link
              >
            </b-nav-item>
            <!-- <b-nav-item-dropdown
              ref="files-drpdwn"
              class="px-1"
              offset="2"
              menu-class="drp-swag border-0"
              no-caret
            >
              <template slot="button-content" class="name-slot">
                <icon-vue
                  class="mr-1 text-yellow f-9 nav-tag"
                  icon="circle"
                  size="xs"
                ></icon-vue>
                Registrations
              </template>
              <div v-for="(file, index) in files" :key="`file-${index}`">
                <b-dropdown-item :href="file.url">
                  <span class="d-block w-100 text-decoration-none">{{
                    file.title
                  }}</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
            </b-nav-item-dropdown> -->
            <b-nav-item class="px-1">
              <router-link
                to="contact"
                active-class="text-inherit"
                class="r-link"
                ><a>
                  <icon-vue
                    class="mr-1 text-yellow f-9 nav-tag"
                    icon="circle"
                    size="xs"
                  ></icon-vue>
                  <span style="font-size: 14px">Contact Us</span>
                </a></router-link
              >
            </b-nav-item>
            <b-nav-item class="px-1">
              <b-button size="sm" class="px-3 btn-buy" @click="goToTicketList"
                >Buy Tickets
              </b-button>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
      <!--end .container-->
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '../../eventBus';
import { dbRefs } from '../../services/firebase/init';

export default {
  data() {
    return {};
  },
  methods: {
    toggleClicked(evt) {
      evt.target.classList.toggle('shown');
    },
  },
  computed: {
    ...mapState({
      files: (state) => state.content.files,
    }),
  },
  async mounted() {
    EventBus.$on('setDefaultHamburger', () => {
      const shownNav = document.getElementsByClassName(
        'navbar-toggler-icon shown',
      );
      if (shownNav && shownNav.length > 0) {
        shownNav[0].classList.remove('shown');
      }
    });
  },
};
</script>

<style scoped lang="scss">
@mixin nav-anchor {
  color: $my-blue;
  font-size: 17px;
  line-height: 1.18;
  text-transform: uppercase;
  /* letter-spacing: 1px; */
  &:hover {
    text-decoration: none;
  }
}

#nav {
  @media (min-width: 1200px) {
    padding: 40px 50px;
  }
}

.navbar-thick {
  font-weight: 600;
  align-items: center;
}
.img {
  width: 150px;
}

ul {
  font-family: 'Roboto', sans-serif !important;
  letter-spacing: 0.17px !important;

  li {
    cursor: pointer;

    a {
      @include nav-anchor;
      /*font-weight: 500;*/
    }
  }
}

.navbar-toggler {
  border: none;
}

@media (max-width: 1200px) {
  .nav-item {
    margin: 0.5em 0;
    font-size: 30px;
  }
  .navbar-nav {
    margin: 0 auto;
    height: 100vh;
    opacity: 0;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    transition: 0.1s ease-out;
  }
  .navbar-collapse {
    background-color: #fff;
    position: absolute;
    align-items: center;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100vw;
    height: 100vh;
    opacity: 1;
    transition: 0.4s ease-out;
  }
  .navbar-collapse.show {
    opacity: 1;
    display: block !important;
    z-index: -1 !important;
    transition-delay: 0.2s;
  }
  .show .navbar-nav {
    opacity: 1;
  }
  .navbar-collapse ul li {
    text-align: center !important;
  }
}

.btn-buy {
  font-size: 17px;
  width: 138px;
  height: 41px;
  border-radius: 20.5px;
  background-color: #f9b233;
  vertical-align: middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 11px 20px;
  line-height: 1.18;
  letter-spacing: -0.2px;
  font-weight: bold;
}

.btn-buy.btn-secondary {
  &:hover {
    background-color: #e4ab45;
  }
}
</style>
